import httpClient from 'shared/lib/httpClient';
import { parseCityList } from '../schemas/MasterDataSchema';

export const getCityList = async (params) => {
  const response = await httpClient.get('/cities', { params });
  return parseCityList(response?.data);
};
